import { get } from "api/apiBridges/httpBridge";
import { useEffect, useMemo, useState } from "react";
import { MenuItem, Select,  Typography } from "@mui/material";
import Scrollbars from "rc-scrollbars";
import {TextInput } from "./LittleComponents";
import { useDispatch, } from "react-redux";
import _ from "lodash";
import { useLocalNotifications } from "components/Events";
import { setState } from "store/slices/dealTab";
import { ReportTable } from "components/reportTable";
import { getDataSource } from "api/ds";
import Loading from 'components/Load';

export default function MoveGuide({deal_id}){

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  // const dispatch = useDispatch();
  console.log("dealID", deal_id)
  // dispatch(setState({DealTab:deal_id}));
  const ds = useMemo(() => getDataSource('moveGuide'), []);

  const { showNotification } = useLocalNotifications();



  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const responseData = await get('Deal/getMoveGuide', { did: deal_id });
        
        const processedData = responseData.map((el) => {
          el.from = { box: el.box, deal: el.deal, count: el.count, addr: el.addr};
          if (el.product) {
            el.info = {
              color: el.product.color, 
              vendorCode: el.product.vendorCode, 
              barcode: el.product.size.barcode, 
              sizeTitle: el.product.size.title
            };
            
            if (el.box === "0") {
              el.type = "UNBOXED"; 
            } else {
              el.type = "DEAL";
            }
          } else {
            el.product = { data: { type: "BOX" } };
            el.type = "BOX";
          }
          return el;
        });

        const getTypeOrder = (type) => {
            if (type === "DEAL") return 2;
            if (type === "BOX") return 1;
            if (type === "UNBOXED") return 3;
            return 4;
        };

        processedData.sort((a, b) => {
            const orderA = getTypeOrder(a.type);
            const orderB = getTypeOrder(b.type);

            if (orderA !== orderB) {
                return orderA - orderB;
            }
            if (a.type === b.type && (a.type === "DEAL" || a.type === "BOX")) {
                 return a.from.box.localeCompare(b.from.box);
            }
            return 0;
        });

        console.log('PROCESS DATA', processedData)
        const finalData = processedData.map(el => {
          console.log('EL TYPE', el.type)
          if (el.type === "BOX" && el.from.box) {
            const match = el.from.box.match(/_B(\d+)/);
            if (match) {
              el.from.box = match[1];
            }
          } 
          return el;
        });

        console.log("RES", finalData);
        setData(finalData);

      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [deal_id]);
  
  if (loading) {
    return (<Loading></Loading>);
  }


  return (
    <div>
      <Scrollbars
        autoHeight autoHeightMax={"80vh"}
        autoHide={true}
        style={{display: 'flex', justifyContent: "flex-start", flexDirection: "column"}}  
      >
        <ReportTable
          ds={ds}
          data={data}
        />
      </Scrollbars>
    </div>
  );
}

export function Additional_feature({type, val, name, title, onChange, values}) {
  switch (type) {
    case "fix":
    case "func":
      return <Typography variant="h4">{title}: {val}</Typography>
    case "input":
      return(
        <TextInput 
          title={title} 
          val={val}
          onChange={(e) => onChange(e)} 
        />
      )
    case "enum":
       return (
        <div style={{width: "48%", marginTop: 5, display:'flex', flexDirection:'row', justifyContent: 'flex-start', alignItems: "center"}}>
          <Typography variant="h4" >{title}</Typography>
          <Select
            style={{width:"100%"}}
            value={val}
            // label="Возможные значения"
            onChange={(e) => onChange(e)} 
          >
            {values? values.map((v) => {return(<MenuItem value={v.val}>{v.name} ({v.val})</MenuItem>)}): <></>}
          </Select>
        </div>
        )
  }
}
